import React, { useContext } from "react";
import "./LongList.scss";
import Icon from "../Icon";

import aurum from "../../../assets/images/aurum.png";
import UserContext from "../../../services/context/userContext";
import FeatherIcon from "feather-icons-react"

export default function LongListItem({ program, item, idx, pagetype, from, removeItem, ...props }) {
  const user = useContext(UserContext);
  // console.log("tu b daky agr",program, pagetype,from,props.phase,item)
  // console.log("user.admin",user.admin)
  // console.log("edit page info", pagetype, { update: true, from: from, phase: props.phase, programID:program, item })
  return (
    
      <div key={idx} className="c-longlist-list-item"  >
        <div className="c-longlist-list-item-data" onClick={() => props.program ? (props.history.push("/" + pagetype, { update: true, from: from, phase: props.phase, programID: props.program, item })) : (props.history.push("/" + pagetype, { update: true, from: from, item,programID: program, }))}>
          <div className="c-longlist-image" style={{ backgroundImage: `url('${item.image}')` }} />
          <div className="c-longlist-title">
            <h3>{item.name}</h3>
            {/* <span>{item.category}</span> */}
          </div>
        </div>
        <div className="c-longlist-text">
          <i className="c-longlist-exercises" >
            {item.supersets && (item.supersets.length + " series")}
          </i>
        </div>
        <div className="c-longlist-icons ">
          {from === "aurum" ? (
            <>
               {/* <div
                    className="copy-btn"
                    style={{marginRight:"10px"}}
                    onClick={() => props.program ? (props.history.push("/" + pagetype, { update: true, from: from, phase: props.phase, programID: props.program, item })) : (props.history.push("/" + pagetype, { update: false, copy: true, from: from, item }))}
                  >
                    Copy to trainer account
                    Copy
                    <FeatherIcon icon="copy" size="13" color="#000" />
                  </div> */}
            
              <div className="c-exercise-user-image" style={{ backgroundImage: `url('${aurum}')` }} />
            </>
          ) : (
            <div className="c-exercise-user-image" style={{ backgroundImage: `url('${user.image}')` }}>
              {user.image === "" && <p>{user.first_name[0] + user.last_name.match(/\b(\w)/g).join("")}</p>}
            </div>
          )}
          <div className="c-longlist-btns">
            {from === "aurum" && !user.admin ? (
              <>
                <div
                    className="copy-btn"
                    style={{marginRight:"10px"}}
                    onClick={() => props.program ? (props.history.push("/" + pagetype, { update: true, from: from, phase: props.phase, programID: program, item })) : (props.history.push("/" + pagetype, { update: false, copy: true, from: from, item }))}
                  >
                    {/* Copy to trainer account */}
                    Copy
                    <FeatherIcon icon="copy" size="13" color="#000" />
                  </div>
              </>
            ) : (
              <>
              <div
                    className="copy-btn"
                    style={{marginRight:"10px"}}
                    onClick={() => props.program ? (props.history.push("/" + pagetype, { update: true, from: from, phase: props.phase, programID: props.program, item })) : (props.history.push("/" + pagetype, { update: false, copy: true, from: from, item }))}
                  >
                    {/* Copy to trainer account */}
                    Copy
                    <FeatherIcon icon="copy" size="13" color="#000" />
                  </div>
                <button  onClick={() => props.program ? (props.history.push("/" + pagetype, { update: true, from: from, phase: props.phase, programID: props.program, item })) : (props.history.push("/" + pagetype, { update: true, from: from, item ,programID:program}))} >
                  <Icon icon="edit" size={20} height={20} />
                </button>
                <button onClick={(e) => { e.stopPropagation(); removeItem(item) }}>
                  <Icon icon="trash" size={20} height={20} />
                </button>
              </>
            )}

          </div>
        </div>

      </div>

   
  );
}
